import Button from './Button';

export default function JobCard({
  job,
  isSelected = false,
  onClick,
  onDelete,
  onViewData,
  onViewInsights,
  showActions = true,
  className = ''
}) {

  const getStatusStyles = (status) => {
    const statusStyles = {
      pending: 'bg-warning-light/30 dark:bg-warning/10 border-warning-light dark:border-warning/30',
      processing: 'bg-brand-primary/10 dark:bg-brand-primary/5 border-brand-primary/30 dark:border-brand-primary/30',
      completed: 'bg-success-light/30 dark:bg-success/10 border-success-light dark:border-success/30',
      failed: 'bg-danger-light/30 dark:bg-danger/10 border-danger-light dark:border-danger/30',
    };
    return statusStyles[status] || statusStyles.pending;
  };

  const handleClick = () => {
    if (onClick) {
      onClick(job);
    }
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (onDelete) {
      onDelete(job.id, e);
    }
  };

  const handleViewData = (e) => {
    e.stopPropagation();
    if (onViewData) {
      onViewData(job.id);
    }
  };

  const handleViewInsights = (e) => {
    e.stopPropagation();
    if (onViewInsights) {
      onViewInsights(job.id);
    }
  };

  return (
    <div
      onClick={handleClick}
      className={`p-4 border rounded-lg transition-all duration-200 ${
        job.status === 'processing' || job.status === 'failed' ? 'cursor-default' : 'cursor-pointer hover:opacity-75'
      } ${getStatusStyles(job.status)} ${className}`}
    >
      <div className="flex justify-between items-center">
        <div className="flex-1">
          <h3 className="font-semibold text-text-primary-light dark:text-primary">
            {job.name}
          </h3>
          <p className="text-sm text-text-secondary-light dark:text-secondary mt-1">
            Created: {new Date(job.created_at).toLocaleString()}
            {job.created_by && job.created_by.name && (
              <> • {job.created_by.name}</>
            )}
          </p>
          {job.status === 'processing' && job.progress !== undefined && (
            <div className="mt-2">
              <div className="flex justify-between text-xs mb-1">
                <span className="text-text-secondary-light dark:text-secondary">Processing</span>
                <span className="text-brand-primary">{job.progress}%</span>
              </div>
              <div className="w-full bg-border-light dark:bg-border rounded-full h-1.5">
                <div
                  className="bg-brand-primary h-1.5 rounded-full transition-all duration-300"
                  style={{ width: `${job.progress}%` }}
                />
              </div>
            </div>
          )}
        </div>
        {showActions && (
          <div className="flex items-center gap-3">
            {job.status === 'processing' && (
              <div className="animate-spin h-5 w-5 border-2 border-brand-primary border-t-transparent rounded-full" />
            )}
            {job.status === 'completed' && (
              <>
                {onViewData && (
                  <Button
                    size="sm"
                    variant="secondary"
                    onClick={handleViewData}
                  >
                    View Data
                  </Button>
                )}
                {onViewInsights && (
                  <Button
                    size="sm"
                    variant="secondary"
                    onClick={handleViewInsights}
                  >
                    View Insights
                  </Button>
                )}
              </>
            )}
            {onDelete && (
              <Button
                size="sm"
                variant="danger"
                onClick={handleDelete}
              >
                Delete
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
